// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Trainingslevel_iconSvg = require("./assets/trainingslevel_icon.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(20), Css.px(2), Css.px(20)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var resetBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* [] */0
    ]);

var resetButtonBox = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* [] */0
    ]);

var topIcon = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(20)),
      /* [] */0
    ]);

var resetHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(5)),
      /* [] */0
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.standardFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(10), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function widerSecondaryGreenButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(180)),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
                Theme.greenSecondaryButtonRaw
              ]
            ]);
}

var centerIcon = Css.style(/* :: */[
      Css.margin4(Css.px(30), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* resetBox */resetBox,
  /* resetButtonBox */resetButtonBox,
  /* topIcon */topIcon,
  /* inputHeader */inputHeader,
  /* resetHeader */resetHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* widerSecondaryGreenButton */widerSecondaryGreenButton,
  /* centerIcon */centerIcon
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Settings");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* resetActive */1];
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: topIcon
                        }, React.createElement("img", {
                              className: centerIcon,
                              alt: "centerIcon",
                              src: Trainingslevel_iconSvg
                            })), React.createElement("h2", undefined, "Belastungsumfang ändern"), React.createElement("p", {
                          className: inputHeader
                        }, "Hier kannst du dein Trainingslevel ändern. Genaue Informationen zum Level und dem Punktemultiplikator findest du in deinem eBook."), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */[30]);
                            })
                        }, "Anfänger"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */[45]);
                            })
                        }, "Fortgeschritten"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */[60]);
                            })
                        }, "Profi"), match !== 0 ? React.createElement("div", {
                            className: resetBox
                          }, React.createElement("p", {
                                className: resetHeader
                              }, "Reset wirklich durchführen?"), React.createElement("div", {
                                className: resetButtonBox
                              }, React.createElement("button", {
                                    className: Theme.verySlimButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Reset */2);
                                      })
                                  }, "Ja"), React.createElement("button", {
                                    className: Theme.verySlimButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* ResetDeactivate */1);
                                      })
                                  }, "Nein"))) : React.createElement("a", {
                            className: someLink,
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* ResetActivate */0);
                              })
                          }, "Reset"), React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/dashboard");
                            })
                        }, "Zurück")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* levelSelect */0,
              /* resetActive : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* levelSelect */state[/* levelSelect */0],
                          /* resetActive : true */1
                        ]]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* levelSelect */state[/* levelSelect */0],
                          /* resetActive : false */0
                        ]]);
          case 2 : 
              return /* SideEffects */Block.__(2, [(function () {
                            Network.resetAll(/* () */0);
                            return ReasonReact.Router[/* push */0]("/wizard/1");
                          })]);
          case 3 : 
              return /* SideEffects */Block.__(2, [(function () {
                            Network.resetAll(/* () */0);
                            return ReasonReact.Router[/* push */0]("/testing");
                          })]);
          
        }
      } else {
        var value = action[0];
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* levelSelect */value,
                    /* resetActive */state[/* resetActive */1]
                  ],
                  (function () {
                      Network.updateWizardResultToLS(value);
                      return ReasonReact.Router[/* push */0]("/dashboard");
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/settings.re
// module id = 132
// module chunks = 0